import React from 'react';
import cx from 'classnames';

const Pill = ({children, className = '', textColor = '', bgColor = '', ...rest}) => {

    const classes = cx(
        'px-4 py-2 rounded-full', 
        className, 
        {
            [`bg-${bgColor}`]: bgColor.length > 0,
            [`text-${textColor}`]: textColor.length > 0
        });

    return (
        <span className={classes} {...rest}>
            {children}
        </span>
    );
};

export default Pill;